import React, { useContext, useEffect } from 'react';
import { navigate, globalHistory } from '@reach/router';
import { PageContext } from '../../context/PageContext';

import { getCreateDraftUrl, getCreateDraftUrlFromCategoryId, getCreateDraftUrlFromCategoryIdAndFolderId } from '../../utilities/urlHelper';
import { EVENTS } from '../../utilities/CONSTANTS';

const canCreateDraft = document.getElementById('new-post-link');

// this is to handle some funk state with creating a draft when in a new draft. Will be fixed in #7497
const isOnCreateDraftRoute = () => globalHistory && globalHistory.location && globalHistory.location.pathname.includes('/drafts/create');

const getNewDraftCategoryId = (page) => {
    if (page) {
        return page.category_id;
    } if (window._tettraDraft) {
        return window._tettraDraft.category_id;
    }
    return null;
};

const getNewDraftFolderId = (page) => {
    if (page) {
        return page.folder_id;
    } if (window._tettraDraft) {
        return window._tettraDraft.folder_id;
    }
    return null;
};

const NewDraftListener = (props) => {
    if (!canCreateDraft) return null;

    const { page, setPage } = useContext(PageContext);

    const onClick = (e) => {
        if (!canCreateDraft || isOnCreateDraftRoute() || !window.loggedIn || !window.userId || e.metaKey || e.ctrlKey) return;
        e.preventDefault();

        const newCategoryId = getNewDraftCategoryId(page);
        const newFolderId = getNewDraftFolderId(page);
        const url = newCategoryId
            ? newFolderId
                ? getCreateDraftUrlFromCategoryIdAndFolderId(newCategoryId, newFolderId)
                : getCreateDraftUrlFromCategoryId(newCategoryId)
            : getCreateDraftUrl();
        window.pageId = null;
        window.page = null;
        window._tettraDraft = null;
        window.draftId = null;
        window.categoryId = null;
        setPage(null);

        return navigate(url);
    };

    useEffect(() => {
        document.getElementById('new-post-link')?.addEventListener('click', onClick);
        return () => document.getElementById('new-post-link')?.removeEventListener('click', onClick);
    });

    return null;
};

export default NewDraftListener;
